"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const thread_1 = require("../../../app/dist/thread");
exports.toolDef = {
    name: 'loom_create_thread',
    description: "Create a thread's manifest (`thread.md`) — the authored roadmap metadata: a stable `th_` ULID identity, a soft `priority`, and hard `depends_on` edges (other threads' `th_` ULIDs). One flat `thread.md` per thread, like `req.md`. This is the FIRST step for any new thread: it mints the `th_` ULID that `loom_create_idea`/`_design`/`_plan`/`_req` then reference via `thread_ulid` (doc-create never fabricates a thread). Returns `{ id }` — the new thread's `th_` ULID. Use this tool — do not edit weave files directly.",
    inputSchema: {
        type: 'object',
        properties: {
            weave_slug: { type: 'string', description: 'Target weave folder slug' },
            thread_slug: { type: 'string', description: 'New thread folder slug (a human slug — the th_ ULID identity is minted for you)' },
            title: { type: 'string', description: 'Optional title (defaults to the thread_slug)' },
            priority: { type: 'number', description: 'Optional soft priority (lower = earlier among dependency-free slack; default 1000)' },
            depends_on: { type: 'array', items: { type: 'string' }, description: 'Optional th_ ULIDs this thread depends on' },
        },
        required: ['weave_slug', 'thread_slug'],
    },
};
async function handle(root, args) {
    const result = await (0, thread_1.createThread)({
        weaveSlug: args['weave_slug'],
        threadSlug: args['thread_slug'],
        title: args['title'],
        priority: args['priority'],
        dependsOn: args['depends_on'],
    }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), saveDoc: dist_1.saveDoc, fs });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
